import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Radium from 'radium';
import { semanticColors, greyScaleColors } from '../../../../Globals/styles';
import {
  attemptGetWorkplaceFeed
} from './actions';
import { getFullDateString } from '../../../../Util/dateTime';
import Waves from 'node-waves'

class Feeds extends Component {
  componentWillMount = () => {
    var isInit = true;
    this.props.dispatch(attemptGetWorkplaceFeed(this.props.workplaceId, isInit));
  };
  componentDidMount = () => {
    Waves.attach('.waves-btn', ['waves-button']);
    Waves.attach('.waves-icon', ['waves-circle']);
  };
  componentDidUpdate = () => {
    Waves.attach('.waves-btn', ['waves-button']);
    Waves.attach('.waves-icon', ['waves-circle']);
  };
  onClick = (goTo, id) => {
    if (goTo)
      this.props.goToDailyReport(new Date(goTo), id);
  };
  onScroll = () => {
    this.props.dispatch(attemptGetWorkplaceFeed(this.props.workplaceId));
  };
  render() {
    const { feeds } = this.props;
    let feedRows = feeds.map((feed) => {
      let isFeedDelete = feed.text.indexOf("slettede") !== -1

      let versionString = feed.data ? (feed.data.version ? " #" + feed.data.version + " for " : " ") : " "
      return (
        <div
          key={feed.id}
          className={feed.goto == null || isFeedDelete ? null : "waves-btn"}
          style={styles.row}
          onClick={() => {
            if (!isFeedDelete)
              this.onClick(feed.goto, feed.data ? feed.data.id : null)
          }}>
          <div style={styles.textContainer}>
            {feed.user ? <span style={styles.user}>{feed.user} </span> : null}
            {feed.text.replace('oprettede nyt tilbud', 'oprettede nyt estimat')}
            {versionString}
            {feed.goto == null ? null : getFullDateString(new Date(feed.goto), true)}
            {feed.data.emails ?
              <span> Til:
              {feed.data.emails.map((email, i) => {
                return (
                  <span key={i}> {email}{i === feed.data.emails.length - 1 ? null : ","}</span>
                )
              })}
              </span>
              :
              null
            }
          </div>
          <div style={styles.timeContainer}>
            {feed.goto == null || isFeedDelete ? null : <i style={styles.icon} className="fa fa-external-link" aria-hidden="true"></i>}
            <div style={styles.time}>{feed.timestamp}</div>
          </div>
        </div>
      )
    });
    return (
      <div style={styles.listsContainer}>
        {feedRows}
      </div>
    )
  }
}

var styles = {
  listsContainer: {
    backgroundColor: '#fff',
    height: '100%',
    width: '100%',
    borderRadius: '2px'
  },
  row: {
    position: 'relative',
    width: '96%',
    marginLeft: '2%',
    height: 'auto !important',
    minHeight: '40px',
    overflow: 'hidden',
    textAlign: 'left',
    lineHeight: 'normal',
    whiteSpace: 'normal',
    padding: '10px 0',
    borderRadius: '0px',
    borderBottom: '1px solid',
    borderColor: semanticColors.mainBackground
  },
  textContainer: {
    width: '70%',
    display: 'inline-block'
  },
  timeContainer: {
    width: '28%',
    display: 'inline-block',
    height: '30px',
    padding: '5px',
    position: 'absolute',
    top: ' 50%',
    right: '0',
    transform: 'translateY(-50%)'
  },
  icon: {
    color: greyScaleColors.greyLight
  },
  time: {
    display: 'inline-block',
    float: 'right',
    color: greyScaleColors.greyLight
  },
  user: {
    fontWeight: '600'
  }
}

const selectProps = state => {
  return {
    ...state.workplaceFeedsReducer
  };
}
Feeds.propTypes = {
  feeds: PropTypes.arrayOf(PropTypes.shape({
    timestamp: PropTypes.string.isRequired,
    text: PropTypes.string.isRequired,
    user: PropTypes.string.isRequired,
    data: PropTypes.object
  })),
  workplaceId: PropTypes.string.isRequired
};
export default connect(selectProps)(Radium(Feeds));


// WEBPACK FOOTER //
// ./src/App/ShortTermProjects/Workplace/Overview/Feed/index.jsx